import Link from 'next/link';

export default function MobileStickyFollow({
  showHeaderSticky,
  mobileSelectors,
  MobileSelect,
  products
}) {
  if (showHeaderSticky === true) {
    return (
      <div
        className={`sticky-wrapper border-dawn-grey-30 fixed top-0 left-0 z-100 flex w-full border-b bg-white`}
      >
        <div className="max-w-container mx-auto w-full">
          <div
            className="flex grid-cols-2 gap-x-[14px] px-4 sm:gap-x-[24px] sm:px-11"
            role="presentation"
          >
            {mobileSelectors?.map((product, index) => {
              return (
                <div className="w-full py-5" key={`selector-${index}`}>
                  <MobileSelect
                    product={product.productTitle}
                    index={index}
                    key={`selector-${index}`}
                    sticky={true}
                  />
                  <Link
                    href={`/products/${products.find((item) => item.reference[0].shopifyProduct[0].title === product.productTitle.concat(' Mattress')).reference[0].shopifyProduct[0].handle}`}
                    prefetch={false}
                  >
                    <button
                      aria-label={`Shop ${product.productTitle}`}
                      className="btn btn-primary mt-2 w-full"
                    >
                      Shop Now
                    </button>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}
